/* -------------------------------------------------------------------------
   Сердечко «нравится».

   Хранится в браузере покупателя, без приложения и без аккаунта. Этого
   достаточно для главного сценария: человек проходит по каталогу, отмечает
   несколько кукол и возвращается за ними вечером с того же устройства.

   Список лежит в одном ключе localStorage, чтобы страница избранного
   собиралась потом простым чтением: window.MRWish.list().

   Разметка:
     [data-mr-wish="<handle>"]  - кнопка
     [data-mr-wish-on]          - картинка «отмечено»
     [data-mr-wish-off]         - картинка «не отмечено»
   ------------------------------------------------------------------------- */

(function () {
  var KEY = 'mr:wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      // Приватный режим или переполненное хранилище: молча работаем без памяти.
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function paint(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var yes = btn.querySelector('[data-mr-wish-on]');
    var no = btn.querySelector('[data-mr-wish-off]');
    if (yes) yes.hidden = !on;
    if (no) no.hidden = on;
    var label = btn.dataset.mrWishLabel || 'Save';
    btn.setAttribute('aria-label', (on ? 'Saved: ' : label + ': ') + (btn.dataset.mrWishTitle || ''));
  }

  function boot(scope) {
    var list = read();
    (scope || document).querySelectorAll('[data-mr-wish]').forEach(function (btn) {
      var handle = btn.dataset.mrWish;
      paint(btn, list.indexOf(handle) !== -1);
      if (btn.dataset.mrWishReady) return;
      btn.dataset.mrWishReady = '1';
      btn.addEventListener('click', function (e) {
        // Кнопка лежит внутри ссылки на товар - переход надо остановить.
        e.preventDefault();
        e.stopPropagation();
        var cur = read();
        var i = cur.indexOf(handle);
        if (i === -1) { cur.push(handle); } else { cur.splice(i, 1); }
        write(cur);
        document.querySelectorAll('[data-mr-wish="' + handle.replace(/"/g, '\\"') + '"]').forEach(function (b) {
          paint(b, i === -1);
        });
        document.dispatchEvent(new CustomEvent('mr:wish', { detail: { handle: handle, saved: i === -1, list: cur } }));
      });
    });
  }

  window.MRWish = {
    list: read,
    has: function (h) { return read().indexOf(h) !== -1; },
    clear: function () { write([]); boot(); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
